module.exports = __webpack_public_path__ + "img/chair_seat.1a7569fc.png";